import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  SoleProprietorshipform1099MiscAnd1099NecStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';
import { requiredFileIf, requiredFiles } from '../../useValidateQuestionnaire';

export const fields: IBaseField<
  keyof SoleProprietorshipform1099MiscAnd1099NecStateValues
>[] = [
  {
    name: 'howManyForms1099MiscOr1099NecIssuesToTheNameOfYourBusinessDidYouReceiveThisYear',
    label:
      'How many Forms 1099-MISC or 1099-NEC issues to the name of your business did you receive this year?',
    type: 'number',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'pleaseUpload1099s',
        label: 'Please upload 1099s.',
        type: 'upload',
        effect: updateKeyInStore(updateKey),

        predicate: (v) => v > 0,
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({
  pleaseUpload1099s: requiredFileIf(
    'howManyForms1099MiscOr1099NecIssuesToTheNameOfYourBusinessDidYouReceiveThisYear',
    (v: number) => v > 0,
  ),
});
